
<template>
  <div>
    <v-list>
      <v-list-item-group v-for="item in order_attributes">

        <v-list-item>
          <v-list-item-icon> <v-icon>{{ item?.icon }}</v-icon> </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-wrap">
              <b v-if="item?.bold">{{ item?.title }}</b>
              <span v-else>{{ item?.title }}</span>
            </v-list-item-title>
            <v-list-item-subtitle> {{ item?.subtitle }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        
      </v-list-item-group>

      <v-list-item-group>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-message</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-textarea no-resize rows="2" auto-grow label="Comentários e observações" v-model="order.comment"></v-textarea>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>

    </v-list>
  </div>
</template>

<script>

export default {
  name: 'OrderResume',
  props: {
    solution: {
      type: String,
      default: false,
    },
    order: {
      type: Object,
      default: []
    }
  },
  data() {
    return {
      order_attributes: []
    }
  },
  computed:{
    total_sell_calculation() {
      var total_aux = 0
      this.order?.items_attributes?.forEach(item => {
        item.bag_sell_price ? total_aux += item.total_bags * Number(item.bag_sell_price.toString().replace(/,/g, '')) : null
      });
      return total_aux.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') || 0
    },
    its_internal_drivers(){
      return this.order?.delivery_attributes?.internal || false
    },
  },
  methods: {
    setData() {
      this.order_attributes = []
      if(this.solution == 'retail'){ this.mapRetailOrder() };
      if(this.solution == 'wholesale' )this.mapWholesaleOrder()
    },
    mapRetailOrder(){ 
      let order = this.order
      
      this.order_attributes.push(
        { icon: 'mdi-truck', title: order?.kind == 'pickup' ? 'Cliente irá retirar': 'Deverá ser entregue', subtitle: 'Entrega' },
        { icon: 'mdi-star', title: order?.is_default_client ? 'CLIENTE FINAL' : order?.client.name, subtitle: 'Cliente' },
      )
      
      order?.items_attributes?.map(el=>{
        this.order_attributes.push(
          {icon: 'mdi-information', title: `${el.product_name}, ${el.total_units_aux} und x R$ ${el.sell_price_aux}; ${order.kind == 'delivery' ? 'Frete: R$' + (el.unit_ship_aux || '0.00') : ''}`, subtitle: 'Produto'}
        )
      })

      let total_price = 0
      total_price = order?.items_attributes?.reduce((all, one) => Number(one.total_sell_price) + all, 0)
      this.order_attributes.push(
        { icon: 'mdi-currency-brl', title: `Total: ${total_price?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}`, subtitle: 'Vendas' }
      )

      if(order?.kind != 'pickup'){
        let units = 0
        units = order?.items_attributes?.reduce((all, one) => Number(one.total_units_aux.replace(/,/g, '')) + all, 0)
        if( order?.shipping_attributes?.building?.attributes?.full_address){
          this.order_attributes.push(
            { icon: 'mdi-map', title: order?.shipping_attributes?.building?.attributes?.full_address, subtitle: 'Endereço de entrega'},
          )
        }else if(order?.shipping_attributes?.building_attributes?.address_attributes){
          let { addr, number, neighborhood, city, state, zip } = order?.shipping_attributes?.building_attributes.address_attributes
          this.order_attributes.push(
            { icon: 'mdi-map', title: `${addr}, ${number}, ${neighborhood}, ${city}, ${state}, ${zip}, Brasil`, subtitle: 'Endereço de entrega'},
          )
        }else if(order?.shipping_attributes?.building_address){
          let { addr, number, neighborhood, city, state, zip } = order?.shipping_attributes?.building_address
          this.order_attributes.push(
            { icon: 'mdi-map', title: `${addr}, ${number}, ${neighborhood}, ${city}, ${state}, ${zip}, Brasil`, subtitle: 'Endereço de entrega'},
          )
        }
        this.order_attributes.push(
          { icon: 'mdi-calendar', title: `${this.formatDate(order?.shipping_attributes?.expected_delivery), units} sacos`, subtitle: 'Data de carregamento e sacos' },
          { icon: 'mdi-truck-fast', title: `R$ ${order?.items_attributes?.reduce((acc,one)=> acc + Number(one.total_ship) , 0).toFixed(2)}`, subtitle: 'Valor de frete total' },
          { icon: 'mdi-account-group', title: order?.shipping_attributes?.number_assistants, subtitle: 'Número de ajudantes' }
        )
      }
    },
    mapWholesaleOrder(){
      if(this.order?.client_name) this.order_attributes.push({ icon: 'mdi-star', title: this.order?.client_name, subtitle: 'Cliente', bold: true }) 
      if(this.order?.without_client) this.order_attributes.push({ icon: 'mdi-account-alert', title: 'Pedido sem cliente ', subtitle: '', bold: true }) 
      if(this.order?.shipping?.building?.attributes?.full_address){
        this.order_attributes.push({ icon: 'mdi-map', title: this.order?.shipping?.building?.attributes?.full_address, subtitle: 'Endereço de entrega' }) 
      }else if(this.order?.shipping?.building_attributes?.address_attributes){
        let { addr, number, neighborhood, city, state, zip } = this.order?.shipping?.building_attributes.address_attributes
        this.order_attributes.push(
          { icon: 'mdi-map', title: `${addr}, ${number}, ${neighborhood}, ${city}, ${state}, ${zip}, Brasil`, subtitle: 'Endereço de entrega'},
        )
      }else if(this.order?.client_shipping_location_attributes?.building_address){
        let { addr, number, neighborhood, city, state, zip } = this.order?.client_shipping_location_attributes?.building_address
        this.order_attributes.push(
          { icon: 'mdi-map', title: `${addr}, ${number}, ${neighborhood}, ${city}, ${state}, ${zip}, Brasil`, subtitle: 'Endereço de entrega'},
        )
      }
      this.order_attributes.push({ icon: 'mdi-sack-outline', title: `${this.order.delivery_attributes?.estimatedLoading}, ${ this.order?.total_order_bags} sacos`, subtitle: 'Data de carregamento e sacos' }) 
      let items = this.order?.items_attributes?.map((i, idx) => {
        if (!i.product?.name) return `Produto ${idx + 1}`
        const sellPrice = Number(String(i.bag_sell_price).replace(/,/g, ''))
        const unitShip = Number(String(i.unit_shipping_price || 0).replace(/,/g, ''))
        const freightPart = unitShip > 0 ? `; Frete: R$ ${unitShip.toFixed(2)}` : ''
        return `${i.product.name}: ${i.total_bags} sacos x ${sellPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}${freightPart}`
      })
      for( let idx in items){
        this.order_attributes.push({ icon: 'mdi-currency-usd', title: items[idx], subtitle: this.order.brand?.name || this.order.brand_name ? `Marca: ${ this.order.brand?.name || this.order.brand_name }` : "Produto" }) 
      }
      this.order_attributes.push({ icon: 'mdi-currency-usd', title: `Total: R$ ${ this.total_sell_calculation }`, subtitle: 'Vendas' }) 
      this.order_attributes.push({ icon: 'mdi-truck', title: this.its_internal_drivers ? "Frete Interno" : "Frete externo", subtitle: 'Frete' }) 
      if(this.order.driver != null && this.order.truck != null) this.order_attributes.push({ icon: 'mdi-truck', title: `${ this.order.driver.name || this.order.driver.attributes?.name }, ${ this.order.truck.plate || this.order.truck.attributes?.plate }`, subtitle: 'Motorista e caminhão' }) 
      const totalShipping = this.order?.items_attributes?.reduce((acc, item) => {
        const bags = Number(item.total_bags) || 0
        const unitShip = Number(String(item.unit_shipping_price || 0).replace(/,/g, '')) || 0
        return acc + (bags * unitShip)
      }, 0) || 0
      if (totalShipping > 0) {
        this.order_attributes.push({
          icon: 'mdi-cart-plus',
          title: `R$ ${totalShipping.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`,
          subtitle: 'Valor do Frete'
        })
      }

      const needsPallets = this.order.delivery_attributes?.needs_pallets
      if (needsPallets === true || needsPallets === false) {
        this.order_attributes.push({
          icon: 'mdi-shipping-pallet',
          title: needsPallets ? 'Sim' : 'Não',
          subtitle: 'Empréstimo de paletes'
        })
      }

    },
    formatDate(date){
      if (!date) return null
      const raw = String(date).substring(0, 10)
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        return this.$moment(raw, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      if (/^\d{2}\/\d{2}\/\d{4}/.test(String(date))) {
        return String(date).substring(0, 10)
      }
      return this.$moment(date).format('DD/MM/YYYY')
    }
  },
  mounted () {
    this.setData();
  },
  watch:{
    order(){
      this.setData()
    }
  }
}
</script>